import { IDictionaryValue } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { IDictionaryValues } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValues';

import { IDictionarySelectOption } from '../interfaces/IDictionarySelectOption';

export const makeCreateDictionarySelectOption = <ValueType extends {}>(
  idProp: keyof ValueType,
  labelProp: keyof ValueType,
) => (
  dictionaryId: IDictionaryValues<ValueType>['idDictionary'],
  dictionaryValue: IDictionaryValue<ValueType>,
): IDictionarySelectOption<ValueType> => ({
  ...dictionaryValue.value,
  id: dictionaryValue.value?.[idProp],
  label: `${dictionaryValue.value?.[labelProp]}`,
  value: {
    dictId: dictionaryId,
    dictVersionId: dictionaryValue.idValue,
  },
});
